import * as redirectdata from "./config/conditionredirect.json";
import Cookies from "js-cookie";
export const conditionalredirect = () => {
  if (navigator.userAgent != "ReactSnap") {
    var ref = document.referrer;
    var currentLocation = window.location.href.split('?')[0];
    //console.log("data print " + JSON.stringify(redirectdata));
    //console.log("Curren Location :" + currentLocation + " referer : " + ref);
    let myArray = redirectdata.default;
    let pathcheck=0;
    for (let i = 0; i < myArray.length; i++) {
      if (currentLocation == myArray[i].page) {
        pathcheck++;
        //console.log("PAGE " + myArray[i].page);
        //console.log("Original Referer : " + ref);
        if (Cookies.get("page-" + i) != myArray[i].page) {
          let childArray = myArray[i].condition;
          //console.log("CONDITION " + myArray[i].condition);
          let k = 0;
          for (let j = 0; j < childArray.length; j++) {
            //console.log("CONDITION " + j + " : " + childArray[j]);
            if ((ref == childArray[j]) || (ref.indexOf('wel.instructure.com') !== -1) || (ref.indexOf('app.efficientlearning.com') !== -1)) {
              Cookies.set("page-" + i, myArray[i].page);
              k++;
              break;
              //console.log("Set Cookie for Page-" + i + " : " + myArray[i].page);
            }
          }
          if (k == 0) {            
              window.location.href = myArray[i].redirect;
          }
        } else {
          //console.log("Cookie Already set for Page-" + i + " : " + myArray[i].page);
        }
        //console.log("REDIRECT " + myArray[i].redirect);
      }
    }
    if ((currentLocation.indexOf('.efficientlearning.com/instructor-resources-') !== -1) && (pathcheck == 0)) {
      let k = 0;
      var path =window.location.pathname;
      if (Cookies.get("page-regmatch"+path) != currentLocation) {
        if ((ref.indexOf('wel.instructure.com') !== -1) || (ref.indexOf('app.efficientlearning.com') !== -1)) {
          Cookies.set("page-regmatch"+path, currentLocation);
          k++;
        }
        if (k == 0) {            
            window.location.href = "https://"+window.location.hostname+"/";
        }
      }
    }
  }
};